// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6da065f5","239":"f8a6063e","453":"1b7d41ae","455":"521cee66"}[chunkId] + ".chunk.js";
};